var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStock = function SvgStock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m18.333 14.167-6.557-6.558c-.33-.33-.495-.495-.685-.556a.83.83 0 0 0-.515 0c-.19.061-.355.226-.685.556L7.609 9.89c-.33.33-.495.495-.685.557a.83.83 0 0 1-.515 0c-.19-.061-.355-.226-.685-.557L1.667 5.833m16.666 8.334H12.5m5.833 0V8.333"
  })));
};
export default SvgStock;